interface ConfidenceBadgeProps {
  confidence: number;
  className?: string;
}

function getConfidenceColor(confidence: number): string {
  if (confidence >= 0.9) return 'text-green-700 bg-green-50 border-green-200';
  if (confidence >= 0.7) return 'text-orange-700 bg-orange-50 border-orange-200';
  if (confidence >= 0.4) return 'text-yellow-700 bg-yellow-50 border-yellow-200';
  return 'text-gray-600 bg-gray-50 border-gray-200';
}

function getConfidenceLabel(confidence: number): string {
  if (confidence >= 0.9) return 'Very High';
  if (confidence >= 0.7) return 'High';
  if (confidence >= 0.4) return 'Moderate';
  return 'Low';
}

export default function ConfidenceBadge({ confidence, className = '' }: ConfidenceBadgeProps) {
  const pct = Math.round(confidence * 100);
  return (
    <span
      className={`inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full border ${getConfidenceColor(confidence)} ${className}`}
      title={`${getConfidenceLabel(confidence)} confidence`}
    >
      {pct}%
    </span>
  );
}
